<template>
  <div>
    <div class="panel panel-primary">
      <div class="panel-heading padding-0">
        <h3 class="text-center panel-title">
          <a href="#content-theme" data-toggle="collapse" class="collapsable-link-panel collapsable-link-panel-child">
            Conversation Theme
          </a>
        </h3>
      </div>
      <div id="content-theme" class="collapse">
        <div class="panel-body message-table-container collapse">
          <div>
            <div>
              <div class="row">
                <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <nv-select v-model="selectedCountry" v-on:change="getLanguagesInCountry()" class="form-control">
                          <option value="">--Choose Country--</option>
                          <option v-for="(value, key) in countryAndLanguages" :key="key" :value="key">{{key}}</option>
                        </nv-select>
                      </div>
                    </div>
                    <div class="row">
                      <div style="margin-top:15px" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <nv-select class="form-control" v-model="messageLanguage">
                          <option value="">--Choose Language--</option>
                          <option v-for="(value, index) in languages" :key="index" :value="value.alias">{{value.name}}</option>
                        </nv-select>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-8 col-lg-8 col-xs-8 col-sm-8">
                    <div class="row">
                      <div class="col-md-10 col-lg-10 col-sm-10 col-xs-10">
                        <textarea v-model="messageText" rows="4" class="form-control" placeholder="message" v-bind:class="{'form-group--error': messageText && messageText.length > 120 }" />
                        <span v-if="messageText && messageText.length > 120 " class="text-red pull-right">Message should be less than or equal to 120 characters.</span> 
                      </div>
                      <div class="text-center col-md-1 col-lg-1 col-sm-1 col-xs-1">
                        <i class="fa fa-plus-circle add-property" v-on:click="addLanguageTranslation" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <table v-if="Object.keys(messageSets).length" class="table table-striped margin-top-20">
                <thead>
                  <th class="width-100">Country</th>
                  <th class="width-100">Language</th>
                  <th>Text</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </thead>
                <tbody v-for="(value, key) in messageSets" :key="key">
                    <tr v-bind:key="language" v-for="(messageRow, language, iSub) in value">
                      <td style="width:10%; background-color: #e8e8e8;" :rowspan="Object.keys(value).length"
                        v-if="iSub === 0">
                        <h4><strong>{{key}}</strong></h4>
                      </td>
                      <td style="width:7%; background-color: #f3f2f2;"><strong>
                          <h4>{{language}}</h4>
                        </strong></td>
                      <td style="width:71%">{{messageRow}}</td>
                      <td style="width:6%" class="align-center"><i class="fa fa fa-pencil" v-on:click="editTranslation(language,key)"
                          aria-hidden="true"></i></td>
                      <td style="width:6%" class="align-center"><i class="fa fa-times-circle"
                          v-on:click="deleteTranslation(value,language, key)" aria-hidden="true"></i></td>
                    </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-text-messages',
  props: ['conversationTheme', 'countryAndLanguages'],
  components: {
  },
  data () {
    return {
      messageSets: this.conversationTheme,
      languages: [],
      messageLanguage: '',
      selectedCountry: '',
      messageText: ''
    }
  },
  methods: {
    getLanguagesInCountry () {
      if (!this.selectedCountry) {
        this.languages = []
      } else {
        this.languages = this.countryAndLanguages[this.selectedCountry]
      }
    },
    addLanguageTranslation () {
      this.messageText = this.messageText.trim()

      if (this.messageSets.length === 0) this.messageSets = {}
      if (this.messageLanguage && this.messageText && this.messageText.length <= 120) {
        if (this.messageSets[this.selectedCountry]) {
          this.messageSets[this.selectedCountry][this.messageLanguage] = this.messageText
        } else {
          this.messageSets[this.selectedCountry] = {}
          this.messageSets[this.selectedCountry][this.messageLanguage] = this.messageText
        }
        this.messageLanguage = ''
        this.messageText = ''
        this.selectedCountry = ''
      } else {
        let text = 'You must select theme language & enter conversation theme'
        if (this.messageLanguage && !this.messageText) {
          text = 'Please enter conversation theme'
        } else if (this.messageText && !this.messageLanguage && this.messageText.length <= 120) {
          text = 'Please select theme language'
        } else if (this.messageText && this.messageText.length > 120) {
          text = 'Theme limit is 120 characters'
        }
        this.$swal({
          type: 'error',
          text
        })
      }
    },
    editTranslation (language, country) {
      this.selectedCountry = country
      this.languages = this.countryAndLanguages[this.selectedCountry]
      this.messageLanguage = language
      this.messageText = this.messageSets[country][language]
    },
    deleteTranslation (_value, language, country) {
      const messageSet = JSON.parse(JSON.stringify(this.messageSets))
      if (Object.keys(messageSet).length === 1 && Object.keys(messageSet[country]).length === 1) {
        delete messageSet[country]
        this.messageSets = messageSet
      } else {
        if (Object.keys(messageSet[country]).length === 1) {
          delete messageSet[country]
        } else {
          delete messageSet[country][language]
        }
      }
      this.messageSets = {
        ...this.messageSets,
        ...messageSet
      }
    },
    getData () {
      return this.messageSets
    }
  },
  watch: {
    conversationTheme: function (value) {
      this.messageSets = value
    }
  }
}
</script>
<style scoped>
  .panel-primary {
      border-color: #0D9488
  }
  .panel-primary > .panel-heading {
    border-color: #0D9488
  }
  .message-table-container {
    display: flex;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// conversationTheme.vue?d6c80a66